import { Pipe, PipeTransform } from '@angular/core';
import { PosEnumResolverService } from '../../services/pos-enum-resolver.service';

@Pipe({
  name: 'enumLookup',
  pure: true
})
export class EnumLookupPipe implements PipeTransform {
  constructor(private enumLookupsResolver: PosEnumResolverService) {}

  transform(key: string, option: string, metaKey?: string): any {
    return metaKey ? this.enumLookupsResolver.getMetaValue(key, option, metaKey) : this.enumLookupsResolver.getDisplayValue(key, option);
  }
}
